import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { RolPlataforma } from '../../core/models/novedades.models';
import { RoleContextService } from '../../core/services/role-context.service';
import { titleFromSlug } from '../../core/utils/text-format.util';
import { AccessibilityToolbar } from '../../shared/components/accessibility-toolbar/accessibility-toolbar';
import { UserSessionSummary } from '../../shared/components/user-session-summary/user-session-summary';
import { SidebarMenu } from '../../shared/sidebar-menu/sidebar-menu';

@Component({
  selector: 'app-modulo-placeholder',
  imports: [CommonModule, RouterLink, SidebarMenu, AccessibilityToolbar, UserSessionSummary],
  templateUrl: './modulo-placeholder.html',
  styleUrl: './modulo-placeholder.css',
})
export class ModuloPlaceholder {
  // Estado base del módulo genérico mientras las vistas definitivas se implementan.
  slug = '';
  rol: RolPlataforma = 'postulante';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly roleContext: RoleContextService
  ) {
    this.route.paramMap.subscribe((params) => {
      // El slug define el título visible del módulo placeholder.
      this.slug = params.get('slug') ?? '';
    });
    this.route.queryParamMap.subscribe((params) => {
      // Conserva contexto de rol entre navegación de módulos.
      this.rol = this.roleContext.resolveRole(params, this.rol);
    });
  }

  get titulo(): string {
    return titleFromSlug(this.slug);
  }
}
